
	<section id="content">
		<!-- <div class="spinner-container">
			<div class="spinner">
				<div class="sk-folding-cube">
					<div class="sk-cube1 sk-cube"></div>
					<div class="sk-cube2 sk-cube"></div>
					<div class="sk-cube4 sk-cube"></div>
					<div class="sk-cube3 sk-cube"></div>
				</div>
			</div>

			<script>
				$("body").css("overflow-y", "hidden");
				setTimeout(() => {
					$(".spinner-container").fadeOut();
					$("body").css("overflow-y", "auto");
				}, 5000);
			</script>
		</div> -->
		<div class="form-group">
			<div class="card">
				<div class="card-title">
					<h2>Settings</h2>
				</div>
				<div class="cont">
					<div class="group" sec:authorize="hasAuthority('user_management')">
						<div class="collapse-title" aria-expanded="false" aria-controls="userManagementGroup"
							data-toggle="collapse" data-target="#userManagementGroup">User Management</div>
						<div class="collapse in" id="userManagementGroup">
							<div class="group-cont">
								<div class="table-responsive">
									<table class="table editable" id="user-table">
										<thead>

										</thead>
										<tbody>

										</tbody>
									</table>
								</div>
							</div>
							<!-- /.group-cont -->
						</div>
					</div>
					<div class="group" sec:authorize="hasAuthority('customer_management')">
						<div class="collapse-title" aria-expanded="false" aria-controls="customerManagementGroup"
							data-toggle="collapse" data-target="#customerManagementGroup">Customer Management
						</div>
						<div class="collapse in" id="customerManagementGroup">
							<div class="group-cont">
								<div class="table-responsive">
									<table class="table editable" id="customer-table">
										<thead>

										</thead>
										<tbody>

										</tbody>
									</table>
								</div>
							</div>
							<!-- /.group-cont -->
						</div>
					</div>
					<div class="group" sec:authorize="hasAuthority('lookup_management')">
						<div class="collapse-title" aria-expanded="false" aria-controls="lookupManagementGroup"
							data-toggle="collapse" data-target="#lookupManagementGroup">Lookup Management</div>
						<div class="collapse in" id="lookupManagementGroup">
							<div class="group-cont">
								<div class="form-group">
									<!-- <div>
										<div class="multiple_select_checkbox"
											style="width: 150px; height: 60px; overflow-x: hidden; overflow-y: auto; border: 1px solid #CCCCCC;">
											<div id="multiple_select_checkbox_choice">
												<input type="checkbox" name="slt_username" value="Siva" />Siva
											</div>
											<div id="multiple_select_checkbox_choice">
												<input type="checkbox" name="slt_username" value="Raja" />Raja
											</div>
											<div id="multiple_select_checkbox_choice">
												<input type="checkbox" name="slt_username" value="Kumar" />Kumar
											</div>
											<div id="multiple_select_checkbox_choice">
												<input type="checkbox" name="slt_username" value="1004" />Vijay
											</div>
										</div>
										<br />
										<button onclick="javascript:validate();">Validate</button>

									</div> -->
									<div class="row">
										<div class="col-md-6 col-xs-12">
											<div class="inputs">
												<select id="lookupSelector">
													<option selected="">Select</option>
													<option value="source">Source</option>
													<option value="sector">Sector</option>
													<option value="status">Status</option>
													<option value="role">Roles</option>
													<option value="region">Region</option>
													<option value="customerNeed">Customer Need</option>
													<option value="productType">Product Type</option>
													<option value="item">Item</option>
													<option value="category">Category</option>
												</select> <label for="lookupSelector">Lookup</label>
											</div>
										</div>
									</div>
									<!-- /.row -->
								</div>
								<div class="table-responsive">
									<table class="table editable" id="lookup-table">
										<thead>

										</thead>
										<tbody>

										</tbody>
									</table>
								</div>
							</div>
							<!-- /.group-cont -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
